"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPalmTour = function SvgPalmTour(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.107 5.965C11.734 4.976 10.296 3 7.527 3 4.757 3 3.355 4.976 3 5.965h9.107Zm0 0C12.692 4.482 14.183 3 16.74 3c2.045 0 3.692 1.976 4.26 2.965h-8.893Zm0 0c2.13 0 4.952.264 6.656 3.017 1.364 2.203.213 4.695-.532 5.665-.328-3.19-2.668-4.729-4.58-5.342m-1.544-3.34v3.017m0-3.017c-4.048 0-6.178 1.43-6.977 3.282-.799 1.853-.532 3.812.799 5.241.285-2.962 2.515-4.467 4.42-5.116m1.758-.39a7.853 7.853 0 0 0-1.758.39m1.758-.39c.431.037.968.138 1.544.323M5.13 20.523c1.686-1.01 5.09-4.655 5.218-11.15m3.302-.068c.23 2.275.032 7.703-2.61 11.218m-7.668-.846c.603.44 2.45 1.323 5.006 1.323 3.195 0 3.78-1.535 7.881-1.535 1.545 0 2.823.476 4.74 1.535"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgPalmTour);
var _default = Memo;
exports["default"] = _default;